import React from 'react'
import { ToastContainer } from 'react-toastify';

export const Toaster = () => {
  return (
    <ToastContainer position="top-center" autoClose={3000} />
  )
}
